import { AlertCircle } from 'lucide-react';
import {
  useOptionalRegisteredComponent,
  type ResourcePreviewLoaderProps,
} from '../registry/PluginComponentRegistry';

export function ResourcePreview(props: ResourcePreviewLoaderProps) {
  const HostResourcePreview = useOptionalRegisteredComponent('ResourcePreview');
  if (HostResourcePreview) {
    return <HostResourcePreview {...props} />;
  }

  return (
    <div
      className="flex items-center gap-2 text-[12px] text-muted-foreground"
      data-testid="resource-preview-missing"
    >
      <AlertCircle className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span className="truncate">
        No preview available{props.fallbackName ? ` for ${props.fallbackName}` : ''}.
      </span>
    </div>
  );
}
